var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { MatDialogRef } from '@angular/material';
import { SetChapters } from 'src/app/story/state/chapters/story.chapters.actions';
import { StoryState } from 'src/app/story/state/story.state';
import { takeUntil } from 'rxjs/operators';
import { SetStoryText } from 'src/app/story/state/story.actions';
import { BookmarksState } from 'src/app/bookmarks/state/bookmarks.state';
import { SetBookmarkText } from 'src/app/bookmarks/state/bookmarks.actions';
var ContentDialogComponent = /** @class */ (function () {
    function ContentDialogComponent(formBuilder, dialogRef, data, store) {
        this.formBuilder = formBuilder;
        this.dialogRef = dialogRef;
        this.data = data;
        this.store = store;
        this.ngUnsubscribe = new Subject();
    }
    ContentDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Initialize chapter form
        this.chapterForm = this.formBuilder.group({
            displayName: ['', Validators.maxLength(60)],
            description: ['', Validators.maxLength(2000)]
        });
        // Initialize bookmark form
        this.bookmarkForm = this.formBuilder.group({
            displayName: ['', [Validators.maxLength(60), Validators.required]]
        });
        // Initialize chapters
        this.chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        // Select a starting chapter
        if (this.data.chapterId) {
            this.selectChapter(this.data.chapterId);
        }
        else {
            this.selectChapter(this.chapters[0].id);
        }
        // Load bookmark once on open
        var bookmark = this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
        this.setBookmarkFormValues(bookmark);
        // Handle chapter form changes
        this.chapterForm.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.handleChapterFormChanges();
        });
        // Handle bookmark form changes
        this.bookmarkForm.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.handleBookmarkFormChanges();
        });
    };
    ContentDialogComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ContentDialogComponent.prototype.handleChapterClick = function (chapter) {
        this.selectChapter(chapter.id);
    };
    ContentDialogComponent.prototype.handleChapterFormChanges = function () {
        var _this = this;
        var chapterIndex = this.chapters.findIndex(function (_chapter) { return _chapter.id === _this.selectedChapter.id; });
        this.chapters[chapterIndex].info.description = this.chapterForm.get('description').value;
        this.chapters[chapterIndex].info.displayName = this.chapterForm.get('displayName').value;
        this.store.dispatch(new SetChapters(this.chapters));
    };
    ContentDialogComponent.prototype.handleBookmarkFormChanges = function () {
        var bookmark = this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
        var story = this.store.selectSnapshot(StoryState.getStory);
        var displayName = this.bookmarkForm.get('displayName').value;
        this.store.dispatch(new SetStoryText(displayName));
        this.store.dispatch(new SetBookmarkText(displayName));
    };
    ContentDialogComponent.prototype.selectChapter = function (chapterId) {
        this.selectedChapter = this.store.selectSnapshot(StoryChaptersState.getStoryChapters)
            .find(function (_chapter) { return _chapter.id === chapterId; });
        if (this.selectedChapter) {
            this.setChapterFormValues(this.selectedChapter);
        }
    };
    ContentDialogComponent.prototype.setChapterFormValues = function (chapter) {
        this.chapterForm.setValue({
            'displayName': chapter.info.displayName,
            'description': chapter.info.description
        });
    };
    ContentDialogComponent.prototype.setBookmarkFormValues = function (bookmark) {
        this.bookmarkForm.setValue({
            displayName: bookmark.title
        });
    };
    ContentDialogComponent.prototype.closeDialog = function () {
        this.dialogRef.close(this.chapters);
    };
    // return css block for image
    ContentDialogComponent.prototype.getImageStyle = function (chapter) {
        var thumbnails = this.store.selectSnapshot(StoryChaptersState.getRegisteredThumbnails);
        var thumbnail = thumbnails.get(chapter.id);
        // use snapshot if present, otherwise use small
        if (thumbnail) {
            var url = (thumbnail.snapshot) ? thumbnail.snapshot : thumbnail.urls.small;
            return {
                'background-image': "url(" + url + ")",
                'background-size': 'cover'
            };
        }
        else {
            return {};
        }
    };
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], ContentDialogComponent.prototype, "chapters$", void 0);
    return ContentDialogComponent;
}());
export { ContentDialogComponent };
